import React, { useEffect, useState } from "react";

import cuid from "cuid";
import {
  Box,
  Button,
  IconButton,
  Checkbox,
  FormControlLabel,
  TextField,
  Typography,
} from "@material-ui/core";

import { AddCircle } from "@material-ui/icons";

import { Row } from "react-bootstrap";

import { getAllTestimonials } from "../../../setting/_crud/settingCrud";

import MicrositeToggle from "./MicrositeToggle";
import "./style/microsites.css"
import Divider from "@material-ui/core/Divider";

const MicrositeTestimonials = ({
  value,
  selected,
  onChange,
  onSelect,
  disabled,
  refetch = false,
  setRefetch = () => {},
  showModal = () => {},
}) => {
  const [searchTestimonials, setSearchTestimonials] = useState("");
  const [testimonials, setTestimonials] = useState([]);
  const [filteredTestimonials, setFilteredTestimonials] = useState([]);
  const [hidingClass, setHidingClass] = useState("d-none");

  useEffect(() => {
    fetchTestimonials();
  }, []);

  useEffect(() => {
    if (refetch) {
      setRefetch(false);
      fetchTestimonials();
    }
  }, [refetch]);

  useEffect(() => {
    if (!searchTestimonials) {
      setFilteredTestimonials(testimonials);
    } else {
      setFilteredTestimonials(
        testimonials.filter(
          (testimonial) =>
            String(testimonial.heading)
              .toLowerCase()
              .includes(searchTestimonials) ||
            testimonial?.contacts?.filter(
              (tc) =>
                String(tc.first_name)
                  .toLowerCase()
                  .includes(searchTestimonials) ||
                String(tc.last_name)
                  .toLowerCase()
                  .includes(searchTestimonials)
            )?.length > 0
        )
      );
    }
  }, [searchTestimonials]);

  const fetchTestimonials = () => {
    getAllTestimonials("limit=100")
      .then((res) => {
        if (res.status === 200) {
          setTestimonials(res.data.data);
          setFilteredTestimonials(res.data.data);
        }
      })
      .catch((err) => console.log("error loading testimonails", err));
  };

  return (
    <>
      <MicrositeToggle
        label="Testimonials"
        name="testimonials"
        disabled={disabled}
        value={value}
        onChange={onChange}
      >
        <Box marginRight={2}>
          <IconButton onClick={() => showModal(true)}>
            <AddCircle style={{ color: "#822433" }} />
          </IconButton>
        </Box>
      </MicrositeToggle>

      {!disabled && value ? (
        <Box className="show_more_box">
          <TextField
            name="testimonials_quick_search"
            label={false}
            placeholder="Quick search name or agent"
            className="w-100"
            disabled={disabled}
            onChange={(e) => setSearchTestimonials(e.target.value)}
            value={searchTestimonials}
          />
          {filteredTestimonials?.length > 0 ? (
            <>
              {filteredTestimonials.map((testimonial, index) => (
                <Row
                  className={`${index > 4 ? hidingClass : ""}`}
                  key={cuid()}
                  style={{ marginLeft: 8 }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={
                          selected[`testimonial_${testimonial.id}`] ?? false
                        }
                        onChange={(e) => {
                          onSelect({
                            ...selected,
                            [e.target.name]: e.target.checked,
                          });
                        }}
                        name={`testimonial_${testimonial.id}`}
                      />
                    }
                    label={testimonial.heading}
                  />
                </Row>
              ))}
            </>
          ) : (
            <Typography variant="subtitle2" style={{ padding: "8px" }}>
              No testimonials found
            </Typography>
          )}

          {filteredTestimonials?.length > 4 ? (
            <Box textAlign="center">
              <Button
                onClick={() => setHidingClass(!hidingClass ? "d-none" : "")}
                color="primary"
              >
                {!hidingClass ? "Show less" : "Show more"}
              </Button>
            </Box>
          ) : null}
        </Box>
      ) : null}
      <Divider/>
    </>
  );
};

export default MicrositeTestimonials;
